/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import socketAction from '../action/socketAction'

export const initialState = ({
  driverList: [],
  pickupList: [],
})


export default function (state = initialState, action) {
  switch (action.type) {

    case socketAction.TYPES.GET_PICKUP_LOCATION_SUCCESS:
      return Object.assign({}, state, { pickupList: action.payload})

    case socketAction.TYPES.UPDATE_DRIVER_LIVE_LOCATION_LIST:
      return Object.assign({}, state, { driverList: action.payload})


    case socketAction.TYPES.UPDATE_DRIVER_LIVE_LOCATION: {
      if(state.driverList != undefined){
        let notFound = true
        let list = state.driverList.map(item => {
          if(item.id == action.payload.driver.id){
            notFound = false
            return action.payload.driver
          }else{
            return item
          }
        })
        if(notFound){
          list.push(action.payload.driver)
        }
        return Object.assign({}, state, { driverList: list})
      }

      return Object.assign({}, state, { driverList: [action.payload.driver]})
    }
    default:
      return state
  }
}
